import { Button } from "@chakra-ui/react";
import { useState } from "react";
import { useDocumentDownloader } from "./DownloadDocumentIconButton/useDocumentDownloader";
import { PreviewPdfModal } from "./PreviewPdfModal";

interface Props {
  documentId: string;
  documentName: string;
  // When set, resolves the link via the sourcing-event-scoped (access-restricted) route.
  eventId?: string;
}

export const PreviewDocumentButton = ({ documentId, documentName, eventId }: Props) => {
  const { getDownloadLink, getSeV2AttachmentDownloadLink } = useDocumentDownloader();
  const [previewUrl, setPreviewUrl] = useState<string>();
  const [isOpeningPreview, setIsOpeningPreview] = useState(false);

  const openPreview = async () => {
    setIsOpeningPreview(true);
    const url = await (
      eventId ? getSeV2AttachmentDownloadLink(eventId, documentId) : getDownloadLink(documentId, false)
    ).catch(() => undefined);
    setIsOpeningPreview(false);
    if (url) setPreviewUrl(url);
  };

  return (
    <>
      <Button
        variant="link"
        size="sm"
        fontWeight="normal"
        color="smPrimary"
        isLoading={isOpeningPreview}
        loadingText={documentName}
        onClick={openPreview}
      >
        {documentName}
      </Button>
      {previewUrl && (
        <PreviewPdfModal
          url={previewUrl}
          documentName={documentName}
          onClose={() => setPreviewUrl(undefined)}
        />
      )}
    </>
  );
};
